import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap5';

const teamName = (teams, id) => {
  const team = teams.find((item) => item.value === id);
  return team ? team.label : '';
};

export default function MemberItem({ member, removeMember, teams }) {
  return (
    <div className="program-card position-relative mb-3">
      <div className="icon-with-text position-absolute top-0 start-0 mt-2 ms-2">
        <i className="small-icon user-icon" />
      </div>

      <Button
        variant="link"
        className="position-absolute top-0 end-0 mt-2 me-2 icon-with-text"
        onClick={() => removeMember(member)}
      >
        <i className="small-icon trash-icon" />
      </Button>

      <div className="ms-4 me-4">
        <div className="row mb-1">
          <div className="col-sm-4"><div className="fw-light">First Name</div></div>
          <div className="col-sm-8"><div className="fw-semibold text-truncate">{member.firstName}</div></div>
        </div>

        <div className="row mb-1">
          <div className="col-sm-4"><div className="fw-light">Last Name</div></div>
          <div className="col-sm-8"><div className="fw-semibold text-truncate">{member.lastName}</div></div>
        </div>

        <div className="row mb-1">
          <div className="col-sm-4"><div className="fw-light">Email</div></div>
          <div className="col-sm-8"><div className="fw-semibold text-truncate">{member.email}</div></div>
        </div>

        <div className="row mb-1">
          <div className="col-sm-4"><div className="fw-light">Team</div></div>
          <div className="col-sm-8">
            <div className="fw-semibold text-truncate">{teamName(teams, member.team)}</div>
          </div>
        </div>

        {member.error && (
          <div className="row mb-1">
            <div className="col-sm-4"><div className="fw-light">Error</div></div>
            <div className="col-sm-8"><div className="fw-semibold text-danger">{member.error}</div></div>
          </div>
        )}
      </div>
    </div>
  );
}

MemberItem.propTypes = {
  member: PropTypes.object.isRequired,
  removeMember: PropTypes.func.isRequired,
  teams: PropTypes.arrayOf(PropTypes.object),
};

MemberItem.defaultProps = {
  teams: [],
};
